import React from "react";
import { useSettings, getYouTubeId } from "../lib/settings";
import { Play, ArrowUpRight } from "lucide-react";

const FeaturedVideo = () => {
  const { settings } = useSettings();
  const s = settings || {};

  if (!s.show_featured_video) return null;

  const videoId = getYouTubeId(s.featured_video_youtube_url);
  const thumbnail = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

  return (
    <section className="section-tight bg-[var(--ri-cream)]">
      <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
        <a
          href={s.featured_video_youtube_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="relative block aspect-video rounded-2xl overflow-hidden bg-black group shadow-[0_20px_40px_-20px_rgba(0,0,0,0.35)]"
        >
          {thumbnail ? (
            <img
              src={thumbnail}
              alt={s.featured_video_title || "Featured video"}
              loading="lazy"
              className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
            />
          ) : (
            <div className="w-full h-full bg-[var(--ri-ink)]" />
          )}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 rounded-full bg-white/95 flex items-center justify-center group-hover:scale-105 transition-transform">
              <Play size={24} className="text-[var(--ri-red)] ml-1" fill="currentColor" />
            </div>
          </div>
        </a>

        <div>
          <p className="eyebrow mb-3">{s.featured_video_eyebrow || "Featured on YouTube"}</p>
          <h2 className="font-serif-display text-[30px] md:text-[36px] leading-[1.08]">
            {s.featured_video_title}
          </h2>
          {s.featured_video_description && (
            <p className="mt-4 text-[15px] leading-[1.7] text-[var(--ri-ink-soft)]">
              {s.featured_video_description}
            </p>
          )}
          <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2">
            {s.featured_video_creator && (
              <span className="text-[13.5px] font-medium text-[var(--ri-muted)]">
                {s.featured_video_creator}
              </span>
            )}
            {s.featured_video_youtube_url && (
              <a
                href={s.featured_video_youtube_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-[var(--ri-red)] link-underline"
              >
                Watch on YouTube <ArrowUpRight size={14} />
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedVideo;
